var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.type,
    {
      directives: [
        {
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: _vm.copy,
          expression: "copy",
          arg: "copy",
        },
        {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: _vm.onCopySuccess,
          expression: "onCopySuccess",
          arg: "success",
        },
        {
          name: "clipboard",
          rawName: "v-clipboard:error",
          value: _vm.onError,
          expression: "onError",
          arg: "error",
        },
      ],
      tag: "component",
      class: _vm.type === "i" ? "el-icon-document-copy" : "",
      attrs: { type: "text" },
    },
    [_vm._v(_vm._s(_vm.type === "el-button" ? _vm.$t("copyText") : ""))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }